// Time Zone Options (based on legacy system)
export const TIMEZONE_OPTIONS = [
  { value: 'America/St_Johns', label: 'Newfoundland Time (NST/NDT)' },
  { value: 'America/Halifax', label: 'Atlantic Time (AST/ADT)' },
  { value: 'America/New_York', label: 'Eastern Time (EST/EDT)' },
  { value: 'America/Chicago', label: 'Central Time (CST/CDT)' },
  { value: 'America/Denver', label: 'Mountain Time (MST/MDT)' },
  { value: 'America/Los_Angeles', label: 'Pacific Time (PST/PDT)' },
  { value: 'America/Anchorage', label: 'Alaska Time (AKST/AKDT)' },
  { value: 'America/Phoenix', label: 'Mountain Time (No DST)' },
  { value: 'America/Regina', label: 'Central Time (No DST)' },
] as const

export const DEFAULT_TIMEZONE = 'America/Chicago'
export const DEFAULT_LIST_MAX = 100
export const DEFAULT_DEBUG_MODE = true
export const DEFAULT_DEVICE_TIMEOUT_HOURS = 6
